import React from 'react';
import {useNavigate} from "react-router";

import {BadgeTemplate} from "@/components/templates/";
import {Button} from "@/components/atoms/";
import { api } from '@/api/strapi';

import s from './login.module.scss';

interface LoginPageProps {
    children?: React.ReactNode;
};

export const BadgeLoginPage: React.FC<LoginPageProps> = (props) => {
    const navigate = useNavigate();
    
    return (
        <BadgeTemplate className={s['home-page']}>
            <div className={s['home-page__text-container']}>
                <h1 style={{margin: '0 0 .5rem'}}>Take a selfie in front of the Walmart Badge Sign!</h1>
                <h4>Please log in with your Walmart User ID to find and display your name</h4>
                <Button
                    onClick={() => window.location.href = api.getBadgeLoginUrl()}
                    style={{margin: '2rem auto'}}
                >Log in</Button>
            </div>
            {props.children}
        </BadgeTemplate>
    );
};
